/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsFeaturedCollection = {
  init: function($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsFeaturedCollection = $.extend(this, window.PXUTheme.getSectionData($section));

    if(this.enable_masonry_layout && !this.align_height && this.collection_style == 'grid') {
      window.PXUTheme.applyMasonry();
    }

    if(this.collection_style == 'slider') {
      this.createSlider();
    }


  },
  createSlider: function() {

    let featuredCollectionSlider = $('.featured-collection.layout--slider .slider-gallery');

    const slideData = {
      products_per_slide: this.products_per,
      products_available: this.products_available,
      products_limit: this.products_limit,
      cellAlign: "left",
      wrapAround: true
    }

    $(featuredCollectionSlider).each(function() {
      const $slider = $(this);
      const isBestSellersCarousel = $slider.closest('.best-sellers-carousel').length > 0;
      const useMobileGrid = isBestSellersCarousel && window.matchMedia('(max-width: 798px)').matches;

      if (useMobileGrid) {
        $slider.addClass('best-sellers-mobile-grid');
        return;
      }

      $slider.flickity({
        lazyLoad: 2,
        freeScroll: true,
        imagesLoaded: true,
        draggable: true,
        cellAlign: isBestSellersCarousel ? slideData.cellAlign : 'center',
        wrapAround: slideData.wrapAround,
        pageDots: false,
        contain: true,
        prevNextButtons: slideData.products_limit > slideData.products_per_slide ? true : false,
        initialIndex: 0,
        arrowShape: arrowShape,
        on: {
          ready: function() {
            // Resize flickity when the slider is settled
            $slider.on( 'settle.flickity', function() {
              $slider.flickity('resize')
            });
          }
        }
      });
    });

  },
  unload: function($section) {
    let $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
  }
}

/******/ })()
;
